function openVideoPopup() {

  console.log('adasd');

  var videoPopup = document.getElementById('videoPopup');
  var videoPlayer = document.getElementById('videoPlayer');

  // Set the video source
  var videoUrlRaw = document.querySelector('input[name="aboutvideourl"]');
  var videoUrl = videoUrlRaw.value;
  videoPlayer.src = videoUrl;

  // Autoplay the video
  videoPlayer.play();

  videoPopup.style.display = 'flex';
}

function closeVideoPopup() {
  var videoPopup = document.getElementById('videoPopup');
  var videoPlayer = document.getElementById('videoPlayer');

  // Pause the video when closing the popup
  videoPlayer.pause();

  videoPopup.style.display = 'none';
}

document.addEventListener('DOMContentLoaded', function() {
  var openButton = document.getElementById('openPopupButton');
  if (openButton) {
      openButton.addEventListener('click', openVideoPopup);
  }

  var closeButton = document.getElementById('closeButton');
  if (closeButton) {
      closeButton.addEventListener('click', closeVideoPopup);
  }
});